import styled from 'styled-components'
import Icon from './Icon'

const ContactsIcon = styled(Icon).attrs({
  type: 'contacts',
})``

export default ContactsIcon
